import { render, staticRenderFns } from "./BottomMenuConfig.vue?vue&type=template&id=c2f552f8&scoped=true"
import script from "./BottomMenuConfig.vue?vue&type=script&lang=js"
export * from "./BottomMenuConfig.vue?vue&type=script&lang=js"
import style0 from "./BottomMenuConfig.vue?vue&type=style&index=0&id=c2f552f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f552f8",
  null
  
)

export default component.exports